<style scoped>
#cnews{
  padding-top: 50px;
  padding-bottom: 5%;
  background-size: cover;
  background-attachment: fixed;
  font-family: 微軟正黑體;
  background-repeat: no-repeat;
}
.hidden{
    display: none;
}
</style>

<template>
    <div class="container-fluid">
        <div style="height:100vh" :class="{'hidden':hidden}"></div>
        <div class="justify-content-center">
            <div class="container-fluid " id="cnews">
                        <h3 class="col-md-12 ">最新消息</h3>
                        <div class="news_body" >
                        <div v-for="item in news" :key="item.id">
                            <div class="row">
                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 offset-lg-1 mt-5 align-self-center">
                                    <img :src="`${route}/${item.images[0].name}`" width='100%'>
                                </div>
                                <div class="col-xl-7 col-lg-7 col-md-7 col-sm-12 mt-5 ml-3">
                                    <router-link :to="`/news/${item.id}`" tag="div" style="cursor: pointer">
                                        <div class="title">
                                            <h2>{{item.title}}</h2>
                                        </div>
                                    <br>
                                    <div class="content" v-html="htmldecode(item.content)">
                                    </div>
                                </router-link>
                            </div>
                        </div>
                        <hr>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>
<script>
export default {
    data(){
        return{
            news:null,
            route:null,
            hidden:false
        }
    },
    mounted(){
        const self = this;
        this.$http.get(`https://www.kcsys.com.tw/kcsys/public/api/v1/news`)
        .then((response) => {
            self.news = response.data.data;
            self.hidden = true;
            self.route = response.data.route;
        })
    },
    methods:{
        htmldecode:function(s){
            var div = document.createElement('div');
            div.innerHTML = s;
            return div.innerText || div.textContent;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/news.vue